import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		vip: false,
		uwp: false,
		country: '',
		newType: 'WORD',
		actTab: '',
		selected: [],
	},
	mutations: {
		change_vip_status(state, status) {
			state.vip = !!status;
		},
		change_uwp_status(state, status) {
			state.uwp = !!status;
		},
		set_new_type(state, type) {
			state.newType = type;
		},
		switch_act_tab(state, tab) {
			state.actTab = tab;
		},
		clear_selected(state) {
			state.selected = [];
		},
		add_selected(state, ids) {
			state.selected = state.selected.concat(ids);
		}
	},
	actions: {

	}
})



// WEBPACK FOOTER //
// ./app/store/index.js